import React, { useEffect, useState } from 'react';

import { PrismicRichText, usePrismicDocumentByUID, useSinglePrismicDocument } from '@prismicio/react';
import { Container, Grid } from '@material-ui/core';

import Treatments from './Treatments';
import LoadingIndicator from './LoadingIndicator';
import ExtraInfoDialog from './ExtraInfoDialog';

import '../assets/scss/home.scss';

const Home = () => {

    const [open, setOpen] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const [homepageDocument, { state: homepageDocumentState }] = useSinglePrismicDocument('home_landingpage');
    const [homepageDialogDocument, { state: homepageDialogDocumentState }] = usePrismicDocumentByUID('dialog', 'homepage-dialog');

    useEffect(() => {
        if (homepageDocumentState === 'loaded' && homepageDocument && 'data' in homepageDocument) {
            setIsLoading(false);
        }
    }, [homepageDocumentState, homepageDocument]);

    const handleClose = () => setOpen(false);
    
    if (isLoading) return <LoadingIndicator />;

    return (
        <>
            
            <Container>
                {/* Homepage content */}
                <Grid container>
                    <Grid item xs={12} md={8}>
                        {homepageDocument && 'data' in homepageDocument && homepageDocument.data.title && (
                            <div className="home__title">
                                <PrismicRichText field={homepageDocument.data.title} />
                            </div>
                        )}

                        {homepageDocument && 'data' in homepageDocument && homepageDocument.data.description && (
                            <div className="home__description">
                                <PrismicRichText field={homepageDocument.data.description} />
                            </div>
                        )}
                    </Grid>
                </Grid>
            </Container>

            {/* Treatments */}
            {homepageDocument && 'data' in homepageDocument && homepageDocument.data.treatment_description && ( 
                <Treatments
                    content={homepageDocument.data.treatment_description}
                />
            )}

            {homepageDialogDocument && 'data' in homepageDialogDocument && (
                <ExtraInfoDialog
                    content={homepageDialogDocument.data}
                    state={homepageDialogDocumentState}
                    open={open}
                    onClose={handleClose}
                />
            )}
        </>
    );
};
export default Home;